// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  pastille: {
    "borderRadius-kaIpWk": "borderRadius-x1f96onm",
    "height-kZKoxP": "height-x1hagigm",
    "width-kzqmXN": "width-xci0xqf",
    $$css: "wino-gc:src/resources/feedback-indicators/Pastille.res.js:8"
  },
  successView: {
    "backgroundColor-kWkggS": "backgroundColor-xhgpr3b",
    $$css: "wino-gc:src/resources/feedback-indicators/Pastille.res.js:13"
  },
  warningView: {
    "backgroundColor-kWkggS": "backgroundColor-x138b76n",
    $$css: "wino-gc:src/resources/feedback-indicators/Pastille.res.js:16"
  },
  dangerView: {
    "backgroundColor-kWkggS": "backgroundColor-xfn4vcz",
    $$css: "wino-gc:src/resources/feedback-indicators/Pastille.res.js:19"
  },
  blankView: {
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    "borderColor-kVAM5u": "borderColor-xsdecx7",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    $$css: "wino-gc:src/resources/feedback-indicators/Pastille.res.js:22"
  }
};
function viewStyleFromParams(variant, color) {
  if (color !== undefined) {
    return {
      backgroundColor: color
    };
  } else if (variant !== undefined) {
    if (variant === "danger") {
      return styles.dangerView;
    } else if (variant === "success") {
      return styles.successView;
    } else {
      return styles.warningView;
    }
  } else {
    return styles.blankView;
  }
}
function Pastille(props) {
  return JsxRuntime.jsx("div", Stylex.props(styles.pastille, viewStyleFromParams(props.variant, props.color)));
}
let make = React.memo(Pastille);
export { make };
/* styles Not a pure module */